"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_router_dom_1 = require("react-router-dom");
var styles_1 = require("./styles");
var Icon_1 = __importDefault(require("../Icon"));
var __1 = require("../..");
var Tile = function (_a) {
    var to = _a.to, image = _a.image, title = _a.title, description = _a.description, onClick = _a.onClick, badgeCount = _a.badgeCount, pspCountError = _a.pspCountError, pspErrorMessage = _a.pspErrorMessage;
    var isMobile = (0, __1.useMediaQuery)({ device: 'mobileLg', filter: 'max' });
    return ((0, jsx_runtime_1.jsxs)(styles_1.TileWrapper, __assign({ as: react_router_dom_1.Link, to: to, "data-testid": title, onClick: onClick }, { children: [(0, jsx_runtime_1.jsx)(styles_1.TileImage, { src: image, alt: title }), (0, jsx_runtime_1.jsxs)(styles_1.TileContent, { children: [(0, jsx_runtime_1.jsxs)(styles_1.TileTitleWrapper, { children: [(0, jsx_runtime_1.jsx)(styles_1.TileTitle, { children: title }), !!badgeCount && (0, jsx_runtime_1.jsx)(__1.Badge, { children: badgeCount })] }), pspCountError && pspErrorMessage ? (0, jsx_runtime_1.jsx)(styles_1.TileErrorMessage, __assign({ size: "xxl" }, { children: pspErrorMessage })) : null, (0, jsx_runtime_1.jsx)(styles_1.TileDescription, __assign({ size: "xxl" }, { children: description })), (0, jsx_runtime_1.jsx)(Icon_1.default, { name: "chevron-right", size: isMobile ? 'l' : 'xl' })] })] })));
};
exports.default = Tile;
